import en_AU from './en-AU'
import zh_Hans from './zh-Hans'
import zh_Hant from './zh-Hant'

export const locales = {
    fallbackWarn: false,
    missingWarn: false,
    globalInjection: true,
    legacy: false,

    fallbackLocale: {
        'zh': ['zh-Hans'],
        'zh-CN': ['zh-Hans'],
        'zh-SG': ['zh-Hans'],
        'yue-Hans': ['zh-Hans'],
        'zh-Hant': ['zh-Hans'],

        'zh-TW': ['zh-Hant'],
        'zh-HK': ['zh-Hant'],
        'zh-MO': ['zh-Hant'],
        'yue-Hant': ['zh-Hant'],

        'en': ['en-AU'],
        'default': ['en-AU'],
    },

    messages: {
        'en-AU': en_AU,
        'zh-Hans': zh_Hans,
        'zh-Hant': zh_Hant,
    }
}